import { REMOVE_ITEMS_REQUEST, REMOVE_ITEMS_SUCCESS, REMOVE_ITEMS_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type RemoveLineItemsErrorAction = GenericAction<
    typeof REMOVE_ITEMS_REQUEST | typeof REMOVE_ITEMS_SUCCESS | typeof REMOVE_ITEMS_ERROR,
    { error: { message: string } }
>

type State = { message: string } | null

const removeLineItemsError = (state: State = null, action: RemoveLineItemsErrorAction) => {
    switch (action.type) {
        case REMOVE_ITEMS_REQUEST:
        case REMOVE_ITEMS_SUCCESS:
            return null
        case REMOVE_ITEMS_ERROR: {
            return action.error
        }
        default:
            return state
    }
}

export default removeLineItemsError
